import React from 'react';
import { ArticleCard, ArticleCardMedia, ArticleCardVariant } from '@lux/article-card';
import { ImageSize, useConfig } from '@browsing/config';
export var BaseArticleCard = function (props) {
    var media = props.media, children = props.children, onClick = props.onClick, _a = props.variant, variant = _a === void 0 ? ArticleCardVariant.COMPACT_INLINE : _a, pdpURLPath = props.pdpURLPath;
    var config = useConfig();
    var imageMedia = media.find(function (item) { return !item.media_type || item.media_type === 'IMAGE'; });
    var image = (imageMedia === null || imageMedia === void 0 ? void 0 : imageMedia.path) ? config.getImage(imageMedia.path, ImageSize.Small) : '';
    var altText = (imageMedia === null || imageMedia === void 0 ? void 0 : imageMedia.alt_text) || '';
    return (React.createElement(ArticleCard, { onClick: onClick, path: pdpURLPath, variant: variant },
        children,
        React.createElement(ArticleCardMedia, { primaryImage: { src: image, alt: altText } })));
};
